import { Injectable } from '@angular/core';
import { HttpServiceParent } from './httpServiceParent';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AutoRunSchedule } from '../domain/auto-run-schedule';
import { AutoRunTask } from '../domain/auto-run-task';
import { PropertyStoreService } from './stores/property-store.service';

@Injectable({
   providedIn: 'root'
})
export class AutoRunService extends HttpServiceParent {
   constructor(
      private http: HttpClient,
      private propertyStore: PropertyStoreService
   ) {
      super(propertyStore);
   }

   getSchedulesForProperty(propId: number): Observable<AutoRunSchedule[]> {
      return this.http.get<AutoRunSchedule[]>(
         `${environment.apiEndpoint}/autorun/schedule/property/${encodeURIComponent(propId)}`
      );
   }

   updateAutoRunTask(
      propId: number,
      autoRunTaskId: number,
      isActive: boolean
   ): Observable<AutoRunTask> {
      return this.http.put<AutoRunTask>(
         `${environment.apiEndpoint}/autorun/property/${encodeURIComponent(propId)}/task/${encodeURIComponent(autoRunTaskId)}`,
         {
            isActive: isActive
         },
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }
}
